const COPY = {
  return: {
    title: "You've Successfully Onboarded to Stripe",
    message:
      "Your Stripe account has been connected and verified. Tap below to return to the app.",
    href: "vupop://stripe-return?source=return",
    icon: (
      <svg
        className="w-20 h-20 sm:w-14 sm:h-14"
        viewBox="0 0 80 80"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <circle
          cx="40"
          cy="40"
          r="30"
          stroke="#FFF528"
          strokeWidth="1.5"
          fill="none"
        />
        <path
          d="M26 40.5 L35.5 50 L54 31"
          stroke="#FFF528"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  refresh: {
    title: "Your Stripe Onboarding Link Has Expired",
    message:
      "This link is no longer valid. Please return to the app to restart the Stripe onboarding process.",
    href: "vupop://stripe-return?source=refresh",
    icon: (
      <svg
        className="w-20 h-20 sm:w-14 sm:h-14"
        viewBox="0 0 80 80"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <circle
          cx="40"
          cy="40"
          r="30"
          stroke="#FFF528"
          strokeWidth="1.5"
          fill="none"
        />
        <path
          d="M40 26 V42 L52 48"
          stroke="#FFF528"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
};

const StripeHandoff = ({ variant }) => {
  const { title, message, href, icon } = COPY[variant];

  return (
    <div className="min-h-screen bg-black flex flex-col items-center justify-center px-6 py-16 text-center font-League_Spartan">
      <div className="mb-10 sm:mb-7">{icon}</div>

      <h1 className="text-2xl sm:text-2xl font-semibold text-white mb-3 tracking-tight">
        {title}
      </h1>

      <p className="text-sm text-gray-500 max-w-xs sm:max-w-sm leading-relaxed mb-10">
        {message}
      </p>

      {/* Custom scheme — required so SFSafariViewController / Custom Tabs
          hand control back to the native app (Universal Links on our own
          domain are blocked in this context). Tap only; no auto-redirect. */}
      <a
        href={href}
        className="inline-block px-8 py-3 bg-[#FFF528]  hover:bg-[#FFF528]/70 text-black text-sm font-semibold rounded-lg
          hover:brightness-105 active:scale-[0.97] transition-all duration-150 no-underline"
      >
        Return to app
      </a>

      <p className="text-xs text-gray-600 max-w-[16rem] sm:max-w-xs leading-relaxed mt-4 px-2">
        Unable to return automatically? Please open the app manually to continue.
      </p>

      <div className="flex items-center gap-3 mt-14">
        <span className="w-1.5 h-1.5 rounded-full bg-[#FFF528] animate-pulse inline-block" />
        <span className="w-1.5 h-1.5 rounded-full bg-[#FFF528] animate-pulse inline-block" />
        <span className="w-1.5 h-1.5 rounded-full bg-[#FFF528] animate-pulse inline-block" />
      </div>
    </div>
  );
};

export const StripeReturn = () => <StripeHandoff variant="return" />;
export const StripeRefresh = () => <StripeHandoff variant="refresh" />;

export default StripeHandoff;
